import { api } from "../ModuloGerenciador/UrlPadrao";

export interface DeletarArquivoViagemDto {
    id: number;
    token: string;
}

export const deletarArquivoViagem = async ({
    id,
    token,
}: DeletarArquivoViagemDto): Promise<string> => {
    const response = await api.delete(`arquivo-viagem/deletar/${id}`, {
        headers: {
            Authorization: token,
        },
    });
    return response.data as string;
};